import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import dockerHero from "../assets/Hero/into-docker.jpg"; // Replace with your hero image
import dockerImage from "../assets/Hero/dockerfile-entry.jpg"; // Replace with your Docker image
import featuresImage from "../assets/Hero/Nairobi.jpg"; // Replace with your features image
import "../assets/css/dockerWebAppsPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const dockerData = {
  hero: {
    title: "Docker Web Apps Setup",
    subtitle: "Streamline Your Web Application Deployment with Docker",
  },
  introduction: {
    heading: "Why Docker Web Apps Setup Matters",
    paragraphs: [
      "Docker simplifies the deployment of web applications by packaging them into containers, ensuring consistency across environments.",
      "Our Docker web apps setup solutions are designed to enhance scalability, portability, and efficiency for your web applications.",
    ],
  },
  features: {
    heading: "Our Docker Web Apps Setup Features",
    items: [
      "Containerized Application Deployment",
      "Seamless Environment Consistency",
      "Automated Build & Deployment Pipelines",
      "Scalable and Portable Solutions",
      "Integrated Monitoring & Logging",
      "24/7 Expert Support",
    ],
  },
  benefits: {
    heading: "Benefits of Our Solutions",
    items: [
      {
        icon: "fa fa-cogs",
        text: "Simplified deployment and management of web applications.",
      },
      {
        icon: "fa fa-shield",
        text: "Enhanced security with isolated container environments.",
      },
      {
        icon: "fa fa-line-chart",
        text: "Scalable solutions to handle growing traffic and workloads.",
      },
      {
        icon: "fa fa-check-circle",
        text: "Compliance with industry standards and best practices.",
      },
      {
        icon: "fa fa-headphones",
        text: "Expert support for seamless Docker operations.",
      },
    ],
  },
  cta: {
    heading: "Ready to Optimize Your Web Application Deployment?",
    text: "Contact us today to learn more about our Docker Web Apps Setup Solutions and how we can help your business thrive.",
  },
};

export const DockerWebAppsPage = ({ data }) => {
  const dockerRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = dockerRef.current.querySelectorAll(".docker-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: dockerRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="docker-page" ref={dockerRef}>
      {/* Hero Section */}
      <div
        className="docker-hero-section"
        style={{ backgroundImage: `url(${dockerHero})` }}
      >
        <h1 className="docker-animate">{dockerData.hero.title}</h1>
        <p className="docker-animate">{dockerData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container docker-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="docker-animate">{dockerData.introduction.heading}</h2>
            {dockerData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="docker-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 docker-image-container">
            <img
              src={dockerImage}
              className="img-fluid docker-animate"
              alt="Docker Web Apps Setup"
            />
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container docker-features">
        <div className="row">
          <div className="col-md-6 docker-image-container">
            <img
              src={dockerHero}
              className="img-fluid docker-animate"
              alt="Docker Features"
              style={{ maxWidth: "100%" }}
            />
          </div>
          <div className="col-md-6">
            <h2 className="docker-animate">{dockerData.features.heading}</h2>
            <ul>
              {dockerData.features.items.map((item, index) => (
                <li key={index} className="docker-animate">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div
        className="container-fluid docker-benefits"
        style={{ backgroundImage: `url(${featuresImage})` }}
      >
        <div className="overlay">
          <h2 className="docker-animate">{dockerData.benefits.heading}</h2>
          <div className="benefits-cards">
            {dockerData.benefits.items.map((item, index) => (
              <div key={index} className="benefit-card docker-animate">
                <i className={item.icon}></i>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container docker-cta">
        <h2 className="docker-animate">{dockerData.cta.heading}</h2>
        <p className="docker-animate">{dockerData.cta.text}</p>
        <button
          className="btn btn-primary docker-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};